export const BI_UOU_ENDPOINT = 'blog-app-uou';
export const BI_UOU_SRC = 69;
//# sourceMappingURL=bi-uou-events.js.map